import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  ReferenceField,
  TextField,
  ShowButton,
} from 'react-admin';
import FullNameField from '../General/FullNameField';

export default props => (
  <List
    {...props}
    title="Push Notificaions"
    bulkActionButtons={false}
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    <Datagrid>
      <DateField source="createdAt" />
      <DateField source="sendCompletedAt" />
      <ReferenceField label="Created by" source="createdByUserId" reference="users" linkType={false} sortable={false}>
        <FullNameField />
      </ReferenceField>
      <TextField source="title" />
      <TextField source="body" />
      <ReferenceField
        label="Offering"
        source="custom.offerId"
        reference="offerings"
        linkType={false}
        sortable={false}
        allowEmpty
      >
        <TextField source="name" />
      </ReferenceField>
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/PushNotification/List.js